import { z } from 'zod'

import { ClientType } from '@/modules/shared/schemas/ClientType'

import { FeatureChange } from './enums/FeatureChange'

export const ReleaseNotes = z.object({
  id: z.string(),
  clientType: ClientType,
  versionMajorNumber: z.number(),
  versionMinorNumber: z.number(),
  createdAt: z.string(),
  description: z.string(),
  videoUrl: z.string().nullable(),
  changes: z.array(FeatureChange)
})

export type ReleaseNotes = z.infer<typeof ReleaseNotes>

export const ReleaseNotesList = z.array(ReleaseNotes)

export type ReleaseNotesList = z.infer<typeof ReleaseNotesList>
